import React, { useState, useEffect } from "react";
import CredItemModal from "./CredItemModal";
import Logout from "./Logout";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { createContext } from "react";
import { getCredList } from "../controllers/CredController";

export const ContextTest = createContext({});

//TODO: add authenticated/logged in check and redirect to login page on failure
export default function CredListView() {
  const [open, setOpen] = React.useState(false);
  const [credList, setCredList] = useState([]);
  const [activeCredItem, setActiveCredItem] = React.useState({
    name: "",
    website: "",
    username: "",
    password: "",
  });
  const [activeCredIndex, setActiveCredIndex] = React.useState(null);
  const [isNewCredItem, setIsNewCredItem] = React.useState(false);
  const keyMaterial = useLocation()?.state?.key;

  const handleClickOpen = (index) => {
    setActiveCredItem(() => credList[index]);
    setActiveCredIndex(() => index);
    setOpen(true);
  };

  const closeCredItemModal = async () => {
    setOpen(() => false);
  };

  useEffect(() => {
    getCredList(keyMaterial, setCredList);
  }, [keyMaterial]);

  return (
    <ContextTest.Provider
      value={{
        keyMaterial: keyMaterial,
        credList: credList,
        setCredList: setCredList,
      }}
    >
      <div className="container" align="center">
        <h1>CloudDBVault</h1>
        <ul>
          {credList.map((credItem, index) => (
            <li key={credItem._id} onClick={() => handleClickOpen(index)}>
              {credItem.name}
            </li>
          ))}
        </ul>
        <CredItemModal
          open={open}
          handleClose={closeCredItemModal}
          activeCredItem={activeCredItem}
          setActiveCredItem={setActiveCredItem}
          credListViewActiveCredItemIndex={activeCredIndex}
          setCredListViewActiveCredItemIndex={setActiveCredIndex}
          isNewCredItem={isNewCredItem}
          setIsNewCredItem={setIsNewCredItem}
        />
        <button
          onClick={() => {
            setIsNewCredItem((isNewCredItem) => true);
            setOpen((open) => true);
          }}
          style={{ backgroundColor: "#04AA6D", width: "100%" }}
        >
          New Credential
        </button>
        <Logout />
        <ToastContainer />
      </div>
    </ContextTest.Provider>
  );
}
